import React from 'react'
import { Button } from '~components/Button'
import { Icon, IconName } from '~components/Icon'
import Modal, { ModalProps } from './Modal'
import * as StyledModal from './Modal.styles'
import * as Styled from './StatusModal.styles'

type Status = 'info' | 'warning' | 'danger' | 'success'

export interface ComponentProps extends ModalProps {
  /**
   * Type of the modal
   */
  type: Status
  /**
   * Inner text
   */
  text: React.ReactNode | string
  /**
   * Label for continue button
   */
  continueLabel?: string
  /**
   * Show status icon or not. Defaults to `true`.
   */
  hasIcon?: boolean
  /**
   * Has disabled state?
   */
  isDisabled?: boolean
  /**
   * Has loading state?
   */
  isLoading?: boolean
}

function getIcon(status: Status) {
  switch (status) {
    case 'danger':
      return IconName.circle_times
    case 'warning':
      return IconName.circle_exclamation
    case 'success':
      return IconName.circle_check
    case 'info':
    default:
      return IconName.circle_info
  }
}

function getButtonColor(status: Status) {
  switch (status) {
    case 'danger':
      return 'danger'
    case 'warning':
      return 'warning'
    case 'success':
      return 'success'
    case 'info':
    default:
      return 'primary'
  }
}

const StatusModal: React.FC<ComponentProps> = ({
  text,
  type,
  onClose,
  continueLabel = 'Continue',
  hasIcon = true,
  isLoading,
  isDisabled,
  ...modalProps
}) => (
  <Modal onClose={onClose} {...modalProps}>
    {text && (
      <Styled.Content spaceForClose={!modalProps.title}>
        {hasIcon && <Icon name={getIcon(type)} size="large" />}
        {text}
      </Styled.Content>
    )}
    <StyledModal.Footer>
      <Button size="small" onClick={onClose} color={getButtonColor(type)} isLoading={isLoading} disabled={isDisabled}>
        {continueLabel}
      </Button>
    </StyledModal.Footer>
  </Modal>
)

export default StatusModal
